import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/category-form',
  	  method: 'get',
        params
  	})
  }

export function show(id) {
    return request({
      url: `/category-form/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/category-form',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/category-form/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/category-form/${id}`,
      method: 'delete',
    })
  }
